// compiled from lib/jquery-jcrop/css/jcrop.css
export const jcropReactStyle = {
  '@global': {
    '.jcrop-active': {
      direction: 'ltr',
      textAlign: 'left',
      boxSizing: 'border-box',
      msTouchAction: 'none',
    },
    '.jcrop-dragging': {
      mozUserSelect: 'none',
      webkitUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
    },
    '.jcrop-selection': {
      zIndex: '2',
      position: 'absolute',
    },
    '.jcrop-selection.jcrop-current': {
      zIndex: '4',
    },
    '.jcrop-border': {
      background: '#ffffff url("Jcrop.gif")',
      lineHeight: '1px !important',
      fontSize: '0 !important',
      overflow: 'hidden',
      position: 'absolute',
      filter: 'alpha(opacity=50) !important',
      opacity: '0.5 !important',
    },
    '.jcrop-border.ord-w, .jcrop-border.ord-e, .jcrop-border.ord-n': {
      top: 0,
    },
    '.jcrop-border.ord-n, .jcrop-border.ord-s': {
      width: '100%',
      height: '1px !important',
    },
    '.jcrop-border.ord-w, .jcrop-border.ord-e': {
      height: '100%',
      width: '1px !important',
    },
    '.jcrop-border.ord-e': {
      right: -1,
    },
    '.jcrop-border.ord-n': {
      top: -1,
    },
    '.jcrop-border.ord-w': {
      left: -1,
    },
    '.jcrop-border.ord-s': {
      bottom: -1,
    },
    '.jcrop-box': {
      zIndex: '2',
      display: 'block',
      background: 'none',
      border: 'none',
      padding: '0',
      margin: '0',
      fontSize: '0',
      width: '100%',
      height: '100%',
      cursor: 'move',
    },
    '.jcrop-box:hover': {
      background: 'none',
    },
    '.jcrop-box:active': {
      background: 'none',
    },
    '.jcrop-box:focus': {
      outline: '1px rgba(128, 128, 128, 0.65) dotted',
    },
    '.jcrop-active, .jcrop-box': {
      position: 'relative',
    },
    '.jcrop-handle': {
      zIndex: '4',
      backgroundColor: 'rgba(49, 28, 28, 0.58)',
      border: '1px #eeeeee solid',
      width: 9,
      height: 9,
      fontSize: '0',
      position: 'absolute',
      filter: 'alpha(opacity=80) !important',
      opacity: '0.8 !important',
    },
    '.jcrop-handle.ord-n': {
      left: '50%',
      marginLeft: -5,
      marginTop: -5,
      top: '0',
      cursor: 'n-resize',
    },
    '.jcrop-handle.ord-s': {
      bottom: '0',
      left: '50%',
      marginBottom: -5,
      marginLeft: -5,
      cursor: 's-resize',
    },
    '.jcrop-handle.ord-e': {
      marginRight: -5,
      marginTop: -5,
      right: '0',
      top: '50%',
      cursor: 'e-resize',
    },
    '.jcrop-handle.ord-w': {
      left: '0',
      marginLeft: -5,
      marginTop: -5,
      top: '50%',
      cursor: 'w-resize',
    },
    '.jcrop-handle.ord-nw': {
      left: '0',
      marginLeft: -5,
      marginTop: -5,
      top: '0',
      cursor: 'nw-resize',
    },
    '.jcrop-handle.ord-ne': {
      marginRight: -5,
      marginTop: -5,
      right: '0',
      top: '0',
      cursor: 'ne-resize',
    },
    '.jcrop-handle.ord-se': {
      bottom: '0',
      marginBottom: -5,
      marginRight: -5,
      right: '0',
      cursor: 'se-resize',
    },
    '.jcrop-handle.ord-sw': {
      bottom: '0',
      left: '0',
      marginBottom: -5,
      marginLeft: -5,
      cursor: 'sw-resize',
    },
    '.jcrop-touch .jcrop-handle': {
      zIndex: '4',
      backgroundColor: 'rgba(49, 28, 28, 0.58)',
      border: '1px #eeeeee solid',
      width: 18,
      height: 18,
      fontSize: '0',
      position: 'absolute',
      filter: 'alpha(opacity=80) !important',
      opacity: '0.8 !important',
    },
    '.jcrop-touch .jcrop-handle.ord-n': {
      left: '50%',
      marginLeft: -10,
      marginTop: -10,
      top: '0',
      cursor: 'n-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-s': {
      bottom: '0',
      left: '50%',
      marginBottom: -10,
      marginLeft: -10,
      cursor: 's-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-e': {
      marginRight: -10,
      marginTop: -10,
      right: '0',
      top: '50%',
      cursor: 'e-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-w': {
      left: '0',
      marginLeft: -10,
      marginTop: -10,
      top: '50%',
      cursor: 'w-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-nw': {
      left: '0',
      marginLeft: -10,
      marginTop: -10,
      top: '0',
      cursor: 'nw-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-ne': {
      marginRight: -10,
      marginTop: -10,
      right: '0',
      top: '0',
      cursor: 'ne-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-se': {
      bottom: '0',
      marginBottom: -10,
      marginRight: -10,
      right: '0',
      cursor: 'se-resize',
    },
    '.jcrop-touch .jcrop-handle.ord-sw': {
      bottom: '0',
      left: '0',
      marginBottom: -10,
      marginLeft: -10,
      cursor: 'sw-resize',
    },
    '.jcrop-dragbar': {
      fontSize: '0',
      position: 'absolute',
    },
    '.jcrop-dragbar.ord-n, .jcrop-dragbar.ord-s': {
      height: '9px !important',
      width: '100%',
    },
    '.jcrop-dragbar.ord-e, .jcrop-dragbar.ord-w': {
      top: 0,
      height: '100%',
      width: '9px !important',
    },
    '.jcrop-dragbar.ord-n': {
      marginTop: -5,
      cursor: 'n-resize',
      top: 0,
    },
    '.jcrop-dragbar.ord-s': {
      bottom: '0',
      marginBottom: -5,
      cursor: 's-resize',
    },
    '.jcrop-dragbar.ord-e': {
      marginRight: -5,
      right: '0',
      cursor: 'e-resize',
    },
    '.jcrop-dragbar.ord-w': {
      marginLeft: -5,
      cursor: 'w-resize',
    },
    '.jcrop-shades': {
      position: 'relative',
      top: '0',
      left: '0',
    },
    '.jcrop-shades div': {
      cursor: 'crosshair',
    },
    '.jcrop-noresize .jcrop-dragbar, .jcrop-noresize .jcrop-handle': {
      display: 'none',
    },
    '.jcrop-selection.jcrop-nodrag .jcrop-box, .jcrop-nodrag .jcrop-shades div': {
      cursor: 'default',
    },
    '.jcrop-light .jcrop-border': {
      background: '#ffffff',
      filter: 'alpha(opacity=70) !important',
      opacity: '.70!important',
    },
    '.jcrop-light .jcrop-handle': {
      backgroundColor: '#000000',
      borderColor: '#ffffff',
    },
    '.jcrop-dark .jcrop-border': {
      background: '#000000',
      filter: 'alpha(opacity=70) !important',
      opacity: '0.7 !important',
    },
    '.jcrop-dark .jcrop-handle': {
      backgroundColor: '#ffffff',
      borderColor: '#000000',
    },
    '.solid-line .jcrop-border': {
      background: '#ffffff',
    },
    '.jcrop-thumb': {
      position: 'absolute',
      overflow: 'hidden',
      zIndex: '5',
    },
    '.jcrop-active img, .jcrop-thumb img, .jcrop-thumb canvas': {
      minWidth: 'none',
      minHeight: 'none',
      maxWidth: 'none',
      maxHeight: 'none',
    },
    '.jcrop-hl-active .jcrop-border': {
      filter: 'alpha(opacity=20) !important',
      opacity: '.20!important',
    },
    '.jcrop-hl-active .jcrop-handle': {
      filter: 'alpha(opacity=10) !important',
      opacity: '.10!important',
    },
    '.jcrop-hl-active .jcrop-selection:hover': {},
    '.jcrop-hl-active .jcrop-selection:hover .jcrop-border': {
      backgroundColor: '#ccc',
      filter: 'alpha(opacity=50) !important',
      opacity: '.50!important',
    },
    '.jcrop-hl-active .jcrop-selection.jcrop-current .jcrop-border': {
      background: '#808080 url(\'Jcrop.gif\')',
      opacity: '.35!important',
      filter: 'alpha(opacity=35) !important',
    },
    '.jcrop-hl-active .jcrop-selection.jcrop-current .jcrop-handle': {
      filter: 'alpha(opacity=30) !important',
      opacity: '.30!important',
    },
    '.jcrop-hl-active .jcrop-selection.jcrop-focus .jcrop-border': {
      background: 'url(\'Jcrop.gif\')',
      opacity: '.65!important',
      filter: 'alpha(opacity=65) !important',
    },
    '.jcrop-hl-active .jcrop-selection.jcrop-focus .jcrop-handle': {
      filter: 'alpha(opacity=60) !important',
      opacity: '.60!important',
    },
    'button.jcrop-box': {
      background: 'none',
    },
  },
};
